import * as React from 'react';
const Circle = ({
  height = '10px',
  width = '10px',
  fillColor = '#2BAB3F',
  ...props
}: {
  height?: string;
  width?: string;
  fillColor?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" {...props}>
    <circle cx={5} cy={5} r={5} fill={fillColor} />
  </svg>
);
export default React.memo(Circle);
